import React from 'react';

import PropTypes from 'prop-types';

import {
    DownloadTheApp,
    TrustpilotReviews,
} from 'wanderu-app-gettheapp';
import Footer from 'wanderu-component-footer';
import InterlinkBlock from 'wanderu-component-interlink';
import {
    Section,
    ValueProps,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import localesConfig from '../../../config/homepage.locales';
import HARDCODED_HOMEPAGE_INTERLINKS from '../../../data/homepageC2CLinkBoostTest.json';
import CarriersSection from '../CarriersSection/CarriersSection';
import FeaturedInSection from '../FeaturedInSection/FeaturedInSection';
import FeaturedRoutes from '../FeaturedRoutes/FeaturedRoutes';
import HeroHeader from '../HeroHeader/HeroHeader';
import HomePageMeta from '../HomePageMeta/HomePageMeta';
import Wanderu101Content from '../Wanderu101Content/Wanderu101Content';

import styles from './HomePage.scss';

function mapHardcodedInterlinks(interlinks, t) {
    const localizedInterlinks = {
        data: {
            bus: HARDCODED_HOMEPAGE_INTERLINKS.map(obj => ({
                placeGuideUrl: obj.placeGuideUrl,
                title: t('homepage:linkflow-c2c-bus', {
                    replace1: obj.departCityName,
                    replace2: obj.arriveCityName,
                }),
                url: obj.url,
            })),
        },
        header: t('homepage:linkflow-popular'),
    };

    return [...interlinks.slice(0, -1), localizedInterlinks];
}

function HomePage(props) {
    const {
        t,
        carriers,
        interlinkData = [],
        locale,
    } = props;

    const hardcodedInterlnkData = mapHardcodedInterlinks(interlinkData, t);

    return (
        <>
            <HomePageMeta
                defaultLocale={localesConfig.defaultLocale}
                locale={locale}
                supportedLocales={localesConfig.supportedLocales}
            />
            <div>
                <HeroHeader
                    locale={locale}
                />
                <Section classes={{ root: styles.section }}>
                    <ValueProps />
                </Section>
                <TrustpilotReviews locale={locale} />
                <DownloadTheApp campaign="web-home_page" />
                <CarriersSection
                    carriers={carriers}
                    locale={locale}
                />
                <Wanderu101Content />
                <FeaturedInSection />
                <FeaturedRoutes locale={locale} />
                <InterlinkBlock
                    subtitle={t('baseApp:link-flow-subtitle')}
                    tabData={hardcodedInterlnkData}
                    title={t('baseApp:link-flow-title')}
                    collapsible
                    noBorder
                    singleTab
                />
            </div>
            <Footer />
        </>
    );
}

HomePage.propTypes = {
    carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
    interlinkData: PropTypes.arrayOf(PropTypes.object),
    locale: PropTypes.string,
    t: PropTypes.func,
};

export {
    HomePage,
};

export default localize(HomePage, ['t']);
